import { Component, OnInit, input } from '@angular/core';
import { BaseComponent } from '@shared-components/base-component';
import { ProductHelper } from '@shared-helpers/productHelper';
import { ProductModel } from '@shared-model/products/ProductModel';

@Component({
  selector: 'fourd-product-display',
  templateUrl: './product-display.component.html',
  providers: [...BaseComponent.componentProviders],
})
export class ProductDisplayComponent extends BaseComponent implements OnInit {
  readonly product = input<ProductModel>(undefined);

  constructor() { super("ProductDisplayComponent"); }

  ngOnInit() { }

  isBundleProduct(product: ProductModel): boolean {
    return ProductHelper.isProductTypeBundle(product?.ProductTypeId);
  }

  isPaygProduct(product: ProductModel): boolean {
    return ProductHelper.isProductTypePayg(product?.ProductTypeId);
  }

  isMinutesProduct(product: ProductModel): boolean {
    return ProductHelper.isProductTypeMinutesTopUp(product?.ProductTypeId);
  }

  isLoyaltyOffer(product: ProductModel): boolean {
    // Offer is the loyalty offer and is applied to this product
    return ProductHelper.isOfferLoyalty(product?.OfferId) && (product?.OfferDiscountAmount?.Amount > 0 || product?.OfferBonusAmount?.Amount > 0);
  }

}
